var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaveLogT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 403,
    viewBox: "0 0 768 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.271 53.8335C660.314 59.685 673.576 66.7067 686.448 74.8988C772.653 128.732 827.262 233.669 811.269 333.925C794.887 435.74 687.228 580.467 580.74 601.532C546.024 608.554 510.528 598.802 476.593 588.269C419.643 570.715 366.204 542.237 310.034 525.853C288.191 519.612 264.397 518.051 243.333 526.633C206.667 541.457 197.695 573.445 182.093 605.824C164.54 642.493 134.895 673.311 99.0085 692.426C25.2859 731.435 -69.8902 713.101 -138.152 670.97C-239.569 608.554 -275.845 485.673 -242.299 374.105C-233.718 345.237 -220.066 316.76 -197.442 296.475C-158.825 261.366 -100.705 255.125 -49.9968 267.998C-14.8908 276.97 17.0946 294.134 47.5198 312.859C72.484 328.463 95.4979 349.919 126.313 349.919C188.724 350.309 207.837 269.948 227.73 225.087C253.865 165.792 297.942 113.909 352.552 79.1899C440.707 22.6256 550.315 12.8731 646.271 53.8335Z",
    fill: "url(#paint0_linear_109_722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.304 54.0706C660.34 59.9209 673.596 66.9412 686.462 75.1316C772.626 128.954 827.21 233.87 811.225 334.105C794.85 435.9 687.242 580.597 580.803 601.658C546.104 608.678 510.624 598.928 476.704 588.397C419.781 570.846 366.367 542.375 310.224 525.994C288.39 519.754 264.607 518.194 243.553 526.774C206.904 541.595 197.937 573.577 182.342 605.948C164.797 642.61 135.166 673.422 99.2963 692.533C25.6082 731.535 -69.5236 713.204 -137.753 671.082C-239.123 608.678 -275.382 485.822 -241.852 374.277C-233.275 345.415 -219.629 316.944 -197.016 296.663C-158.417 261.561 -100.324 255.321 -49.6395 268.191C-14.5499 277.162 17.4206 294.323 47.8316 313.044C72.7842 328.644 95.7873 350.095 126.588 350.095C188.97 350.485 208.074 270.141 227.958 225.289C254.08 166.006 298.137 114.134 352.721 79.4218C440.835 22.869 550.392 13.1185 646.304 54.0706Z",
    fill: "url(#paint1_radial_109_722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-272.335 855.097C-448.645 722.073 -345.667 429.109 -175.988 339.386C-112.407 305.837 -38.2947 292.964 33.0874 302.326C97.4483 310.909 177.802 332.754 243.723 307.788C293.652 288.673 316.666 241.471 342.8 198.56C415.352 79.1899 598.293 56.9542 689.179 170.083C722.724 211.824 736.377 269.948 719.994 321.051C681.377 439.641 551.875 388.928 478.543 452.515C449.288 477.871 441.487 528.584 424.324 562.523C406.771 597.241 385.317 630.4 362.303 661.998C313.935 728.705 255.035 789.56 187.164 836.762C51.8105 931.166 -117.478 959.253 -260.633 863.679C-264.533 860.948 -268.434 858.218 -272.335 855.097Z",
    fill: "url(#paint2_linear_109_722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-272.335 855.097C-448.645 722.073 -345.667 429.109 -175.988 339.386C-112.407 305.837 -38.2947 292.964 33.0874 302.326C97.4483 310.909 177.802 332.754 243.723 307.788C293.652 288.673 316.666 241.471 342.8 198.56C415.352 79.1899 598.293 56.9542 689.179 170.083C722.724 211.824 736.377 269.948 719.994 321.051C681.377 439.641 551.875 388.928 478.543 452.515C449.288 477.871 441.487 528.584 424.324 562.523C406.771 597.241 385.317 630.4 362.303 661.998C313.935 728.705 255.035 789.56 187.164 836.762C51.8105 931.166 -117.478 959.253 -260.633 863.679C-264.533 860.948 -268.434 858.218 -272.335 855.097Z",
    fill: "url(#paint3_radial_109_722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5 239C176.103 239 162 224.897 162 207.5C162 190.103 176.103 176 193.5 176C210.897 176 225 190.103 225 207.5C225 224.897 210.897 239 193.5 239Z",
    fill: "url(#paint4_linear_109_722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 146C39.3416 146 23 129.658 23 109.5C23 89.3416 39.3416 73 59.5 73C79.6584 73 96 89.3416 96 109.5C96 129.658 79.6584 146 59.5 146Z",
    fill: "url(#paint5_linear_109_722)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_722",
    x1: -314.152,
    y1: 727.246,
    x2: 1163.73,
    y2: -79.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_109_722",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.764 -77.0703) rotate(79.7207) scale(1206.28 1124.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_109_722",
    x1: 706.014,
    y1: -400.149,
    x2: -242.163,
    y2: 1116.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_109_722",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(429.435 162.015) rotate(-122.48) scale(1284.19 2158.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9726,
    stopColor: "#D60B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_109_722",
    x1: 119.913,
    y1: 259.344,
    x2: 270.113,
    y2: 153.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_109_722",
    x1: -25.7676,
    y1: 169.573,
    x2: 148.273,
    y2: 46.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703531,
    stopColor: "#FEBB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1178,
    height: 538,
    fill: "white",
    transform: "matrix(-1 0 0 1 814 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveLogT);
export default __webpack_public_path__ + "static/media/waveLog_t.d6b30ce90df0942026965ddc47869a9f.svg";
export { ForwardRef as ReactComponent };